module.exports = __webpack_public_path__ + "img/cart.652c5e2.svg?v=1763034624171";